var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockProduct({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#E84141"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_909_5890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.91675 9.58366V7.50033C7.91675 6.94779 8.13624 6.41789 8.52694 6.02719C8.91764 5.63649 9.44755 5.41699 10.0001 5.41699C10.5526 5.41699 11.0825 5.63649 11.4732 6.02719C11.8639 6.41789 12.0834 6.94779 12.0834 7.50033V9.58366",
    stroke: "#E84141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 9.16699H6.66659C6.20635 9.16699 5.83325 9.54009 5.83325 10.0003V14.167C5.83325 14.6272 6.20635 15.0003 6.66659 15.0003H13.3333C13.7935 15.0003 14.1666 14.6272 14.1666 14.167V10.0003C14.1666 9.54009 13.7935 9.16699 13.3333 9.16699Z",
    fill: "#E84141"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_909_5890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockProduct);
export default __webpack_public_path__ + "static/media/lock_product.182671eb2474e037be1cabd449ed38ef.svg";
export { ForwardRef as ReactComponent };